<main [@routerTransition]="getRouterState(o)">
  <a8-header></a8-header>
  <alert></alert>
  <router-outlet #o="outlet"></router-outlet>
</main>

<a8-nav></a8-nav>
<a8-sidenav></a8-sidenav>
